
/*
 * BUILD @athena/forge v9.0.0
 * THIS IS AN AUTOGENERATED FILE
 */

import React from 'react';
import IconBase from '../_IconBase';
const Print = props => {
  const modClassName = props.className;

  return (
    <IconBase viewBox="0 0 25 25" {...props} className={ modClassName }>
      <g>
        <g className="fe_c_icon__background">
          <rect x="-0.1" y="-0.2" width="25" height="25"></rect>
        </g>
        <g className="fe_c_icon__icon fe_c_icon__icon--primary">
          <path d="M23.8,10.6A3.8,3.8,0,0,0,20,6.8H18.3V.9H6.7V6.8H1.2V20.3H5.6v3.4H19.4V20.3h4.4ZM8.2,2.4h8.6V6.8H8.2Zm9.7,19.8H7.1V16H17.9Zm4.4-3.4H19.4V14.5H5.6v4.3H2.7V8.3H20a2.3,2.3,0,0,1,2.3,2.3Z"></path>
        </g>
      </g>
    </IconBase>);
};

Print.defaultProps = {
  title: 'Print',
};

export default Print;
